import { Box, Container } from "@theme-ui/components"
import React from "react"
import SectionTitle from "./sectionTitle"

const TextBlock = ({ section }) => (
  <Container mt={[3, 5]}>
    <SectionTitle title={section.title} alignement="left" />
    <Box
      sx={{
        img: { width: "100%" },
        table: {
          width: "100%",
          border: "none",
          borderColor: "light",
          fontSize: 0,
          td: {
            width: ["50%", "50%", "25%"],
            display: ["inline-block", "inline-block", "table-cell"],
            verticalAlign: "top",
          },
        },
      }}
      dangerouslySetInnerHTML={{ __html: section.body }}
    />
  </Container>
)

export default TextBlock
